/* Veraperle · theme behaviour */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduceMQ = matchMedia('(prefers-reduced-motion: reduce)');
  let reduced = reduceMQ.matches;

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const fmt = (window.VP && VP.moneyFormat) || '{{amount_with_comma_separator}} €';
    const v = (Number(cents) / 100);
    const withSep = (n, dec, th, dc) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return parts.join(dc);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => {
      switch (k) {
        case 'amount': return withSep(v, 2, ',', '.');
        case 'amount_no_decimals': return withSep(v, 0, ',', '.');
        case 'amount_with_comma_separator': return withSep(v, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withSep(v, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withSep(v, 2, "'", '.');
        default: return withSep(v, 2, '.', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }
  window.VPformatMoney = formatMoney;

  /* ---------- Page visibility: pause every loop on hidden tabs ---------- */
  document.addEventListener('visibilitychange', () => {
    document.body.classList.toggle('paused', document.hidden);
  });

  /* ---------- Section entrances ---------- */
  const rvIO = new IntersectionObserver(entries => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      el.classList.add('in');
      rvIO.unobserve(el);
      // retire the stagger once the entrance has finished, so hovers never lag
      setTimeout(() => el.classList.add('done'), 1600);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });
  $$('.rv').forEach(el => rvIO.observe(el));

  /* ---------- Header over the hero ---------- */
  const header = $('#siteHeader');
  const heroEl = $('#hero');
  if (header && heroEl) {
    let over = null;
    const setOver = () => {
      const limit = heroEl.offsetTop + heroEl.offsetHeight - header.offsetHeight;
      const o = scrollY < limit;
      if (o !== over) { over = o; header.classList.toggle('is-over', o); }
    };
    addEventListener('scroll', setOver, { passive: true });
    addEventListener('resize', setOver, { passive: true });
    setOver();
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    $$('[aria-controls="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const f = d.querySelector('button, a, input, select');
    setTimeout(() => f && f.focus(), 60);
  }
  function closeDrawer(d) {
    d.classList.remove('open');
    d.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    $$('[aria-controls="' + d.id + '"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      if (opener.dataset.open === 'cartDrawer' && document.body.classList.contains('template-cart')) return;
      e.preventDefault();
      if (opener.dataset.open === 'cartDrawer') refreshCart();
      openDrawer(opener.dataset.open);
      return;
    }
    const closer = e.target.closest('[data-close]');
    if (closer) closeDrawer(closer.closest('.drawer'));
  });
  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    const d = $('.drawer.open');
    if (d) closeDrawer(d);
  });

  /* ---------- Cart (AJAX) ---------- */
  const R = (window.VP && VP.routes) || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' };
  function esc(s) { return String(s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c])); }

  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.classList.toggle('has', cart.item_count > 0); });
    const lab = $('[data-cart-count-label]');
    if (lab) lab.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    const lines = $('[data-cart-lines]');
    const foot = $('[data-cart-foot]');
    if (!lines) return;
    if (!cart.item_count) {
      lines.innerHTML = '<div class="cart-empty"><p>' + esc(VP.strings.emptyCart) + '</p><a class="btn" href="' + esc(R.root) + 'collections/all">Ver la colección</a></div>';
      foot.hidden = true;
    } else {
      lines.innerHTML = cart.items.map((it, i) => {
        const img = it.image ? it.image + (it.image.includes('?') ? '&' : '?') + 'width=240' : '';
        const opts = (it.options_with_values || []).filter(o => o.value !== 'Default Title').map(o => esc(o.name) + ': ' + esc(o.value)).join(' · ');
        return '<div class="cart-line">' +
          '<a class="cart-line__img" href="' + esc(it.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div><a class="cart-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
          (opts ? '<div class="cart-line__meta">' + opts + '</div>' : '') +
          '<div class="cart-line__row"><div class="qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity - 1) + '" aria-label="Quitar una">−</button>' +
          '<input type="number" value="' + it.quantity + '" min="0" data-line-input="' + (i + 1) + '" aria-label="Cantidad">' +
          '<button type="button" data-line="' + (i + 1) + '" data-q="' + (it.quantity + 1) + '" aria-label="Añadir una">+</button></div>' +
          '<button class="link-btn" type="button" data-line="' + (i + 1) + '" data-q="0">' + esc(VP.strings.remove) + '</button></div>' +
          ((it.line_level_discount_allocations || []).map(d => '<div class="cart-line__deal">' + esc(d.discount_application.title) + '</div>').join('')) +
          '</div><div class="card__price">' + formatMoney(it.final_line_price) +
          (it.original_line_price > it.final_line_price ? '<s class="cart-line__was">' + formatMoney(it.original_line_price) + '</s>' : '') + '</div></div>';
      }).join('');
      foot.hidden = false;
      $('[data-cart-subtotal]').textContent = formatMoney(cart.total_price);
    }
    // Quantity saving: matches the automatic discount set in Shopify (theme settings, Ofertas)
    const qb = $('[data-qty-banner]');
    const qmin = Number(VP.qty && VP.qty.min) || 0, qpct = Number(VP.qty && VP.qty.pct) || 0;
    if (qb) {
      const n = cart.item_count;
      if (qmin > 1 && qpct > 0 && n > 0) {
        const left = qmin - n;
        $('[data-qty-text]', qb).innerHTML = left > 0
          ? 'Añade ' + left + ' ' + (left === 1 ? 'prenda' : 'prendas') + ' más y <b>ahorra un ' + qpct + ' %</b> en toda la bolsa.'
          : '<b>Ya ahorras un ' + qpct + ' %</b> por llevar ' + qmin + ' o más prendas.';
        qb.classList.toggle('is-done', left <= 0);
        qb.hidden = false;
      } else qb.hidden = true;
    }
    const meter = $('[data-ship-meter]');
    const th = Number(VP.freeShippingThreshold) || 0;
    if (meter && th > 0 && cart.item_count) {
      meter.hidden = false;
      const left = th - cart.total_price;
      $('[data-ship-text]').textContent = left > 0 ? 'Te faltan ' + formatMoney(left) + ' para el envío gratis.' : 'Tienes el envío gratis.';
      $('[data-ship-bar]').style.setProperty('--p', Math.min(1, cart.total_price / th).toFixed(3));
    } else if (meter) meter.hidden = true;
  }
  /* ---------- Sale countdown (real end date from theme settings, Spanish time) ---------- */
  const saleBox = $('[data-sale-timer]');
  const saleEnd = (() => {
    const s = VP.sale && VP.sale.end;
    if (!s || !/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(s)) return null;
    // Read the date as Madrid wall-clock time, whatever the visitor's own time zone
    const guess = new Date(s.slice(0, 16) + ':00Z');
    let off = 60;
    try {
      const name = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Madrid', timeZoneName: 'shortOffset' })
        .formatToParts(guess).find(p => p.type === 'timeZoneName').value;   // "GMT+1" or "GMT+2"
      const m = name.match(/GMT([+-]\d+)/);
      if (m) off = Number(m[1]) * 60;
    } catch (e) { /* older browsers: assume winter time */ }
    return new Date(guess.getTime() - off * 60000);
  })();
  let saleTick = null;
  function paintSale() {
    if (!saleBox || !saleEnd) return false;
    const ms = saleEnd - Date.now();
    if (ms <= 0) { saleBox.hidden = true; return false; }
    const d = Math.floor(ms / 864e5), h = Math.floor(ms / 36e5) % 24, m = Math.floor(ms / 6e4) % 60, s = Math.floor(ms / 1e3) % 60;
    const pad = x => String(x).padStart(2, '0');
    const txt = (d > 0 ? d + (d === 1 ? ' día ' : ' días ') : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    const clock = $('[data-sale-clock]', saleBox);
    if (clock.textContent !== txt) clock.textContent = txt;
    if (saleBox.hidden) {
      $('[data-sale-label]', saleBox).textContent = (VP.sale.label || 'La oferta');
      saleBox.hidden = false;
    }
    return true;
  }
  function startSaleClock() {
    if (saleTick || !paintSale()) return;
    saleTick = setInterval(() => {
      const open = $('#cartDrawer.open');
      if (!open || document.hidden || !paintSale()) { clearInterval(saleTick); saleTick = null; }
    }, 1000);
  }
  new MutationObserver(() => { if ($('#cartDrawer.open')) startSaleClock(); })
    .observe(document.getElementById('cartDrawer') || document.body, { attributes: true, attributeFilter: ['class'] });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && $('#cartDrawer.open')) startSaleClock(); });

  async function refreshCart() {
    try { renderCart(await (await fetch(R.cart + '.js', { headers: { Accept: 'application/json' } })).json()); } catch (e) { /* network hiccup: drawer keeps last state */ }
  }
  async function changeLine(line, quantity) {
    const res = await fetch(R.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity)) })
    });
    renderCart(await res.json());
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('[data-cart-lines] [data-line]');
    if (b) changeLine(b.dataset.line, b.dataset.q);
  });
  document.addEventListener('change', e => {
    const i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.dataset.lineInput, i.value);
  });

  // Product forms add to cart without leaving the page
  document.addEventListener('submit', async e => {
    const form = e.target.closest('form[data-product-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const label = btn.querySelector('span') || btn;
    const prev = label.textContent;
    btn.disabled = true;
    const err = form.querySelector('[data-form-error]');
    if (err) err.textContent = '';
    try {
      const res = await fetch(R.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      label.textContent = VP.strings.added;
      await refreshCart();
      openDrawer('cartDrawer');
      setTimeout(() => { label.textContent = prev; btn.disabled = false; }, 1400);
    } catch (ex) {
      if (err) err.textContent = ex.message;
      label.textContent = prev;
      btn.disabled = false;
    }
  });

  /* ---------- The pearl thread (signature) ---------- */
  const pthread = $('#pthread');
  const path = $('#pthreadPath');
  const pearlsG = $('#pthreadPearls');
  let threadLen = 0, threadTop = 0, threadH = 0, pearls = [], lastDraw = -1;
  function buildThread() {
    if (!pthread || getComputedStyle(pthread).display === 'none') return;
    const main = $('#main');
    const hero = $('#hero');
    const startEl = hero || main;
    const start = hero ? hero.offsetTop + hero.offsetHeight : main.offsetTop + 40;
    const footer = $('.site-footer');
    const end = (footer ? footer.offsetTop : document.body.scrollHeight) - 40;
    threadTop = start;
    threadH = Math.max(0, end - start);
    if (threadH < 200) { pthread.style.display = 'none'; return; }
    pthread.style.top = start + 'px';
    pthread.style.height = threadH + 'px';
    const svg = $('#pthreadSvg');
    const w = pthread.offsetWidth;
    svg.setAttribute('viewBox', '0 0 ' + w + ' ' + threadH);
    const cx = w * 0.55;
    const amp = w * 0.32;
    let d = 'M ' + cx + ' 0';
    const step = 220;
    for (let y = step, i = 0; y <= threadH + step; y += step, i++) {
      const yy = Math.min(y, threadH);
      const x = cx + (i % 2 ? -amp : amp) * (0.6 + 0.4 * Math.sin(i * 1.7));
      d += ' S ' + x.toFixed(1) + ' ' + (yy - step / 2).toFixed(1) + ' ' + cx + ' ' + yy.toFixed(1);
      if (yy >= threadH) break;
    }
    path.setAttribute('d', d);
    path.style.strokeDasharray = '1';
    const total = path.getTotalLength();
    pearlsG.innerHTML = '';
    pearls = $$('[data-pearl]').map(sec => {
      const y = sec.getBoundingClientRect().top + scrollY - start + 24;
      if (y < 0 || y > threadH) return null;
      // find the point on the path at this height
      let lo = 0, hi = total;
      for (let n = 0; n < 18; n++) { const m = (lo + hi) / 2; path.getPointAtLength(m).y < y ? lo = m : hi = m; }
      const pt = path.getPointAtLength(lo);
      const c = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
      c.setAttribute('cx', pt.x.toFixed(1)); c.setAttribute('cy', pt.y.toFixed(1)); c.setAttribute('r', '5.5');
      c.setAttribute('fill', 'url(#ppg)'); c.setAttribute('class', 'pp');
      pearlsG.appendChild(c);
      return { el: c, frac: lo / total, on: false };
    }).filter(Boolean);
    threadLen = total;
    lastDraw = -1;
    drawThread();
  }
  function drawThread() {
    if (!threadLen) return;
    const p = reduced ? 1 : Math.min(1, Math.max(0, (scrollY + innerHeight * 0.7 - threadTop) / threadH));
    if (Math.abs(p - lastDraw) < 0.002) return;
    lastDraw = p;
    path.style.strokeDashoffset = (1 - p).toFixed(4);
    pearls.forEach(pl => {
      const on = p >= pl.frac - 0.004;
      if (on !== pl.on) { pl.on = on; pl.el.classList.toggle('on', on); }
    });
  }
  let threadRaf = null;
  addEventListener('scroll', () => {
    if (threadRaf) return;
    threadRaf = requestAnimationFrame(() => { threadRaf = null; drawThread(); });
  }, { passive: true });
  let rT;
  addEventListener('resize', () => { clearTimeout(rT); rT = setTimeout(buildThread, 200); });
  addEventListener('load', buildThread);
  if (document.fonts) document.fonts.ready.then(buildThread);

  /* ---------- The one interactive moment: thread the pearl ---------- */
  $$('[data-promise]').forEach(sec => {
    const btn = $('[data-hold]', sec);
    const tpath = $('#threadPath', sec);
    const pearl = $('#threadPearl', sec);
    const doneMsg = $('.promise__done', sec);
    if (!btn || !tpath) return;
    const len = tpath.getTotalLength();
    let hold = 0, holding = false, raf = null, last = 0, complete = false;
    const HOLD_MS = 1500;
    function paint() {
      sec.style.setProperty('--hold', hold.toFixed(3));
      const pt = tpath.getPointAtLength(len * hold);
      pearl.setAttribute('cx', pt.x.toFixed(1));
      pearl.setAttribute('cy', pt.y.toFixed(1));
    }
    function finish() {
      complete = true; holding = false; hold = 1; paint();
      sec.classList.add('lit');
      btn.querySelector('span').textContent = 'Perla enhebrada';
      btn.disabled = true;
      doneMsg.textContent = doneMsg.dataset.doneMsg;
    }
    function loop(now) {
      const dt = Math.min(64, now - (last || now)); last = now;
      if (holding) hold = Math.min(1, hold + dt / HOLD_MS);
      else hold = Math.max(0, hold - (dt / 700) * Math.max(0.25, hold)); // eases back, never snaps
      paint();
      if (hold >= 1 && holding) { finish(); raf = null; last = 0; return; }
      if ((holding || hold > 0) && !complete) raf = requestAnimationFrame(loop);
      else { raf = null; last = 0; }
    }
    const start = e => { if (complete) return; if (e) e.preventDefault(); holding = true; if (!raf) raf = requestAnimationFrame(loop); };
    const stop = () => { holding = false; if (!raf && !complete) raf = requestAnimationFrame(loop); };
    btn.addEventListener('pointerdown', start);
    btn.addEventListener('pointerup', stop);
    btn.addEventListener('pointerleave', stop);
    btn.addEventListener('pointercancel', stop);
    btn.addEventListener('keydown', e => { if ((e.key === ' ' || e.key === 'Enter') && !e.repeat) start(e); });
    btn.addEventListener('keyup', e => { if (e.key === ' ' || e.key === 'Enter') stop(); });
    btn.addEventListener('contextmenu', e => e.preventDefault());
    // reduced motion pins the finished state; flipping motion back on hands the hold back to the visitor
    let pinned = false;
    sec._pin = () => { if (!complete) { pinned = true; finish(); } };
    sec._unpin = () => {
      if (!pinned) return;
      pinned = false; complete = false; hold = 0;
      sec.classList.remove('lit');
      btn.querySelector('span').textContent = btn.dataset.label;
      btn.disabled = false;
      doneMsg.textContent = '';
      paint();
    };
    btn.dataset.label = btn.querySelector('span').textContent;
    if (reduced) sec._pin(); else paint();
  });

  /* ---------- Reduced motion, live in both directions ---------- */
  function pinToFinalStates() {
    $$('.rv').forEach(el => el.classList.add('in', 'done'));
    $$('[data-promise]').forEach(s => s._pin && s._pin());
    lastDraw = -1; drawThread();
  }
  function unpinFinalStates() {
    $$('[data-promise]').forEach(s => s._unpin && s._unpin());
    lastDraw = -1; drawThread();
  }
  reduceMQ.addEventListener('change', e => {
    reduced = e.matches;
    if (reduced) pinToFinalStates();
    else { unpinFinalStates(); if (window.VPHero) VPHero.applyHeroMode(); }
  });
  if (reduced) pinToFinalStates();

  /* ---------- Product page ---------- */
  const pform = $('form[data-product-form]');
  if (pform) {
    const variants = JSON.parse(($('#productVariants') || { textContent: '[]' }).textContent);
    const idInput = $('input[name="id"]', pform);
    const buyBtn = $('[data-buy]', pform);
    const priceEl = $('[data-price]');
    const compareEl = $('[data-compare]');
    const saveEl = $('[data-save]');
    const fieldsets = $$('fieldset.opt', pform);
    const sticky = $('.sticky-buy');
    const stockNode = $('#variantStock');
    let stockMap = {};
    try { stockMap = JSON.parse(stockNode ? stockNode.textContent : '{}'); } catch (e) { stockMap = {}; }
    const stockAlert = Number(stockNode && stockNode.dataset.alert) || 0;
    function current() {
      const chosen = fieldsets.map(fs => { const c = $('input:checked', fs); return c ? c.value : null; });
      return variants.find(v => v.options.every((o, i) => o === chosen[i]));
    }
    function sync() {
      fieldsets.forEach(fs => {
        const c = $('input:checked', fs);
        const out = $('legend b', fs);
        if (out && c) out.textContent = c.value;
      });
      const v = current();
      const label = $('span', buyBtn);
      if (!v) { buyBtn.disabled = true; label.textContent = VP.strings.unavailable; return; }
      idInput.value = v.id;
      buyBtn.disabled = !v.available;
      label.textContent = v.available ? VP.strings.addToCart : VP.strings.soldOut;
      if (priceEl) priceEl.textContent = formatMoney(v.price);
      const sp = $('[data-price-sticky]');
      if (sp) sp.textContent = formatMoney(v.price);
      const xp = $('[data-extra-price]');
      if (xp) xp.textContent = formatMoney(v.price - Math.floor(v.price / 10));   // the cart rounds the 10 % discount down to the cent
      const onSale = v.compare_at_price && v.compare_at_price > v.price;
      if (compareEl) { compareEl.textContent = onSale ? formatMoney(v.compare_at_price) : ''; compareEl.hidden = !onSale; }
      if (saveEl) { saveEl.hidden = !onSale; if (onSale) saveEl.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + ' %'; }
      // low-stock note: only variants whose stock Shopify really tracks are in the map
      const stockEl = $('[data-stock]');
      if (stockEl) {
        const q = stockMap[String(v.id)];
        const show = v.available && typeof q === 'number' && q > 0 && q <= stockAlert;
        stockEl.hidden = !show;
        if (show) $('[data-stock-text]', stockEl).textContent = q === 1 ? 'Solo queda 1 unidad en esta talla.' : 'Solo quedan ' + q + ' unidades en esta talla.';
      }
      // mark sizes that are sold out for the current other choices
      fieldsets.forEach((fs, fi) => {
        $$('.pill', fs).forEach(p => {
          const val = $('input', p).value;
          const others = fieldsets.map((f, j) => j === fi ? val : ($('input:checked', f) || {}).value);
          const m = variants.find(vv => vv.options.every((o, k) => o === others[k]));
          p.classList.toggle('na', !m || !m.available);
        });
      });
      // the chosen colour's photo leads: slid into view on phones, moved to the big first slot on desktop
      if (v.featured_media && v.featured_media.id) {
        const g = document.querySelector('[data-media-id="' + v.featured_media.id + '"]');
        if (g && innerWidth <= 900) g.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        else if (g && g.parentElement.firstElementChild !== g) {
          const img = g.querySelector('img');
          if (img) img.loading = 'eager';
          g.parentElement.prepend(g);
          if (!reduced && g.animate) g.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 450, easing: 'cubic-bezier(.22,.61,.36,1)' });
        }
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
    }
    pform.addEventListener('change', e => { if (e.target.closest('fieldset.opt')) sync(); });
    sync();

    // Delivery window: working days from data-min/data-max (prep + transit), weekends skipped
    const eta = $('[data-eta]');
    if (eta) {
      const addWorkdays = (d, n) => { const r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); const w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; };
      const now = new Date();
      const from = addWorkdays(now, Number(eta.dataset.min || 6));
      const to = addWorkdays(now, Number(eta.dataset.max || 13));
      const day = d => d.getDate();
      const month = d => d.toLocaleDateString('es-ES', { month: 'long' });
      const range = from.getMonth() === to.getMonth()
        ? 'entre el ' + day(from) + ' y el ' + day(to) + ' de ' + month(to)
        : 'entre el ' + day(from) + ' de ' + month(from) + ' y el ' + day(to) + ' de ' + month(to);
      ($('[data-eta-text]', eta) || eta).textContent = 'Pídelo hoy y te llega ' + range + '.';
      eta.hidden = false;
    }

    // Phone gallery: "2 / 8" counter that follows the swipe
    const gal = $('.gallery');
    const gcur = $('[data-gcur]');
    if (gal && gcur) {
      let lastIdx = -1, ticking = false;
      gal.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const first = gal.firstElementChild;
          if (!first) return;
          const step = first.getBoundingClientRect().width + 8;
          const idx = Math.min(gal.children.length - 1, Math.round(gal.scrollLeft / step));
          if (idx !== lastIdx) { lastIdx = idx; gcur.textContent = idx + 1; }
        });
      }, { passive: true });
    }

    if (sticky) {
      new IntersectionObserver(es => sticky.classList.toggle('show', !es[0].isIntersecting), { rootMargin: '0px 0px -40px 0px' }).observe(buyBtn);
      $('button', sticky).addEventListener('click', () => pform.requestSubmit ? pform.requestSubmit() : buyBtn.click());
    }
  }

  /* ---------- Search in place: live suggestions (Shopify predictive search) ---------- */
  const sInput = $('[data-search-input]');
  const sResults = $('[data-search-results]');
  const sIdle = $('[data-search-idle]');
  if (sInput && sResults) {
    const cents = v => (typeof v === 'number' ? v : Math.round(parseFloat(String(v || '0').replace(',', '.')) * 100));
    const imgOf = p => {
      const u = (p.featured_image && p.featured_image.url) || p.image || '';
      return u ? u + (u.includes('?') ? '&' : '?') + 'width=200' : '';
    };
    let timer = null, ctrl = null, lastQ = '';
    function showIdle(on) { sIdle.hidden = !on; sResults.hidden = on; }
    async function suggest(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      const url = (R.root || '/') + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last' +
        '&resources[options][fields]=title,product_type,variants.title,tag';
      try {
        const data = await (await fetch(url, { signal: ctrl.signal, headers: { Accept: 'application/json' } })).json();
        if (q !== lastQ) return;
        const res = (data.resources && data.resources.results) || {};
        // Shopify's suggestions tolerate typos ("collar" also brings "Conjunto..."). When some products
        // really contain every word in their name or type, show only those; otherwise keep Shopify's list.
        const norm = s => String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '');
        const words = norm(q).split(/\s+/).filter(Boolean).map(w => w.length > 3 ? w.replace(/(es|s)$/, '') : w);
        const strict = (res.products || []).filter(p => {
          const hay = norm(p.title + ' ' + (p.type || ''));
          return words.every(w => hay.includes(w));
        });
        const prods = strict.length ? strict : (res.products || []);
        const cols = (res.collections || []).filter(c => c.handle !== 'ganadores-oferta-anuncios');
        const all = (R.root || '/') + 'search?q=' + encodeURIComponent(q) + '&options[prefix]=last';
        if (!prods.length && !cols.length) {
          sResults.innerHTML = '<p class="search-empty">No encontramos nada con «' + esc(q) + '». Prueba con otra palabra, como abrigo, botas o conjunto.</p>';
        } else {
          sResults.innerHTML =
            (cols.length ? '<div class="search-group"><span class="label">Colecciones</span><ul class="search-chips">' +
              cols.map(c => '<li><a href="' + esc(c.url) + '">' + esc(c.title) + '</a></li>').join('') + '</ul></div>' : '') +
            (prods.length ? '<div class="search-group"><span class="label">Prendas</span><ul class="search-list">' +
              prods.map(p => {
                const price = cents(p.price), was = cents(p.compare_at_price_max || p.compare_at_price || 0);
                const img = imgOf(p);
                return '<li><a href="' + esc(p.url) + '">' +
                  '<span class="search-list__img">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</span>' +
                  '<span class="search-list__txt"><span class="search-list__t">' + esc(p.title) + '</span>' +
                  '<span class="search-list__p">' + formatMoney(price) + (was > price ? ' <s>' + formatMoney(was) + '</s>' : '') + '</span></span></a></li>';
              }).join('') + '</ul></div>' : '') +
            '<a class="link-arrow search-all" href="' + esc(all) + '">Ver todos los resultados</a>';
        }
        showIdle(false);
      } catch (e) { /* aborted or offline: keep what is on screen */ }
    }
    sInput.addEventListener('input', () => {
      const q = sInput.value.trim();
      lastQ = q;
      clearTimeout(timer);
      if (q.length < 2) { if (ctrl) ctrl.abort(); showIdle(true); return; }
      timer = setTimeout(() => suggest(q), 220);
    });
    // a fresh panel every time it opens
    new MutationObserver(() => {
      const d = $('#searchDrawer');
      if (d && d.classList.contains('open')) setTimeout(() => sInput.focus(), 80);
    }).observe($('#searchDrawer'), { attributes: true, attributeFilter: ['class'] });
  }

  /* ---------- Collection: sort and filters submit on change ---------- */
  $$('[data-autosubmit]').forEach(f => f.addEventListener('change', () => f.submit()));
})();
